import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _parseInt2 from "@babel/runtime-corejs3/core-js/parse-int";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import toastr from "toastr";
import { ACCOUNTS_API, ACCOUNTS_API_PUBLIC, MAIN_API, DOCUMENTS_API, EXTERNAL_API, showToast, RESPONSE_TIME_THRESHOLD_MILLISECONDS } from "./constants";
import Amplitude from "./amplitude";
import { apiWrapper } from "./api/resources";
import { jsonErrorReplacer } from "./utils";
import Vue from "vue";
import { debounce } from "lodash";
const sessionDetailsMiddleware = () => {
  try {
    const {
      apiBasePath,
      userDetails: {
        username
      },
      brokerageDetails: {
        tiedBrokerages
      },
      token
    } = Vue.auth.session.get();
    if (!token) throw new Error("TokenEmpty");
    return {
      apiBasePath,
      username,
      tiedBrokerages,
      token
    };
  } catch (e) {
    var _context;
    if (!_includesInstanceProperty(_context = window.location.href).call(_context, "login")) {
      Amplitude.logEvent("Error while fetching session details");
      return e;
    }
  }
};
const apiErrorHandler = (error, originalParams, resources = {}) => {
  var _errorObject$response, _errorObject$response2;
  const errorObject = error;
  if ((errorObject == null ? void 0 : errorObject.statusText) !== "abort") {
    Amplitude.logEvent("API_ERROR", {
      originalParams: _JSON$stringify(originalParams),
      resources: _JSON$stringify(resources),
      error: error instanceof Error ? jsonErrorReplacer(error) : errorObject
    });
  }
  const refreshTokenError = ((_errorObject$response = errorObject.responseJSON) == null ? void 0 : _errorObject$response.code) === "NotAuthorizedException" && ((_errorObject$response2 = errorObject.responseJSON) == null ? void 0 : _errorObject$response2.message) === "Refresh Token has expired";
  const authTokenError = errorObject.message === "TokenEmpty";
  if (refreshTokenError || authTokenError) {
    toastr.remove();
    debounce(() => {
      showToast("error", "issueRedirectingToLogin");
    }, 1000)();
    Amplitude.logEvent("Session aborted due to refresh token expiration");
    Amplitude.logHandledError(error, {}, "There was an issue with sessionWrapper");
    return Vue.auth.session.end();
  }
  if (error.message === "NoSessionDetails") {
    Vue.auth.ignoreErrorBroadcast = true;
  }
  throw error;
};
const getAPIResourceData = resources => {
  if (!resources || resources.length < 2) return {};
  if (resources[1] instanceof Error) throw Error;
  if (!resources[1]) throw new Error("NoSessionDetails");
  return resources[1];
};
const makeApiCall = ajaxOptions => {
  const startTime = new Date().getTime();
  return $.ajax(_objectSpread(_objectSpread({}, ajaxOptions), {}, {
    complete(jqXHR) {
      try {
        var _parseInt;
        const timeToCompleteRequest = new Date().getTime() - startTime;
        const contentLength = (_parseInt = _parseInt2(jqXHR.getResponseHeader("content-length") || "")) != null ? _parseInt : 0;
        if (timeToCompleteRequest >= RESPONSE_TIME_THRESHOLD_MILLISECONDS) {
          Amplitude.logEvent("RESPONSE_TIME_ABOVE_THRESHOLD", {
            type: ajaxOptions == null ? void 0 : ajaxOptions.type,
            url: ajaxOptions == null ? void 0 : ajaxOptions.url,
            time: timeToCompleteRequest,
            responseTimeThresholdMilliseconds: RESPONSE_TIME_THRESHOLD_MILLISECONDS,
            contentLengthKB: (contentLength / 1000).toFixed(1)
          });
        }
      } catch (_unused) {}
    }
  }));
};
export const postSecureAccountsApi = apiWrapper(async ({
  resources,
  params
}) => {
  const [data, endpoint] = params;
  const {
    username,
    token
  } = getAPIResourceData(resources);
  return makeApiCall({
    data: _JSON$stringify(data),
    type: "POST",
    headers: {
      "content-type": "application/json",
      "x-auth-token": token
    },
    url: `${ACCOUNTS_API}/${username}${endpoint}`
  });
}, [([, endpoint]) => ({
  name: "postSecureAccountsApi",
  url: `${ACCOUNTS_API}/{username}${endpoint}`,
  type: "POST"
}), sessionDetailsMiddleware], apiErrorHandler);
export const postSecureMfaApi = apiWrapper(async ({
  params
}) => {
  const [data, endpoint] = params;
  return makeApiCall({
    data: _JSON$stringify(data),
    type: "POST",
    headers: {
      "content-type": "application/json",
      "x-auth-token": data.token
    },
    url: `${ACCOUNTS_API}/${data.username}${endpoint}`
  });
}, [([, endpoint]) => ({
  name: "postSecureMfaApi",
  url: `${ACCOUNTS_API}/{username}${endpoint}`,
  type: "POST"
})], apiErrorHandler);
export const postPublicEncodedAccountsApi = apiWrapper(async ({
  params
}) => {
  const [data, endpoint] = params;
  return makeApiCall({
    data,
    type: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    },
    url: `${ACCOUNTS_API_PUBLIC}${endpoint}`
  });
}, [([, endpoint]) => ({
  name: "postPublicEncodedAccountsApi",
  url: `${ACCOUNTS_API_PUBLIC}${endpoint}`,
  type: "POST"
})], apiErrorHandler);
export const postAccountsApi = apiWrapper(async ({
  params
}) => {
  const [data, endpoint] = params;
  return makeApiCall({
    data: _JSON$stringify(data),
    type: "POST",
    headers: {
      "content-type": "application/json"
    },
    url: `${ACCOUNTS_API}${endpoint}`
  });
}, [([, endpoint]) => ({
  name: "postAccountsApi",
  url: `${ACCOUNTS_API}${endpoint}`,
  type: "POST"
})], apiErrorHandler);
export const putSecureMfaApi = apiWrapper(async ({
  params
}) => {
  const [data, endpoint] = params;
  return makeApiCall({
    data: _JSON$stringify(data),
    type: "PUT",
    headers: {
      "content-type": "application/json",
      "x-auth-token": data.token
    },
    url: `${ACCOUNTS_API}/${data.username}${endpoint}`
  });
}, [([, endpoint]) => ({
  name: "putSecureMfaApi",
  url: `${ACCOUNTS_API}/{username}${endpoint}`,
  type: "PUT"
})], apiErrorHandler);
export const putAccountsApi = apiWrapper(async ({
  resources,
  params
}) => {
  const [data, endpoint] = params;
  const {
    username,
    token
  } = getAPIResourceData(resources);
  const url = `${ACCOUNTS_API}/${username}${endpoint}`;
  return makeApiCall({
    data: _JSON$stringify(data),
    type: "PUT",
    headers: {
      "content-type": "application/json",
      "x-auth-token": token
    },
    url
  });
}, [([, endpoint]) => ({
  name: "putAccountsApi",
  url: `${ACCOUNTS_API}/{username}${endpoint}`,
  type: "PUT"
}), sessionDetailsMiddleware], apiErrorHandler);
export const IPData = () => {
  const url = "https://api.ipdata.co";
  const API_KEY = "768afdca11e9a11d74a25137bf82d67bd28bcfc8888d34ccc6b052d3";
  return makeApiCall({
    data: {
      "api-key": API_KEY
    },
    type: "GET",
    url
  });
};
export const deleteAccountsApi = apiWrapper(async ({
  resources,
  params
}) => {
  const [endpoint] = params;
  const {
    username,
    token
  } = getAPIResourceData(resources);
  const url = `${ACCOUNTS_API}/${username}${endpoint}`;
  const request = {
    type: "DELETE",
    headers: {
      "content-type": "application/json",
      "x-auth-token": token
    },
    url
  };
  return makeApiCall(request);
}, [([endpoint]) => ({
  name: "deleteAccountsApi",
  url: `${ACCOUNTS_API}/{username}${endpoint}`,
  type: "DELETE"
}), sessionDetailsMiddleware], apiErrorHandler);
export const getSecureAccountsApi = apiWrapper(async ({
  resources,
  params
}) => {
  const [data, endpoint] = params;
  const {
    username,
    token
  } = getAPIResourceData(resources);
  const url = `${ACCOUNTS_API}/${username}${endpoint}`;
  const request = {
    type: "GET",
    headers: {
      "content-type": "application/json",
      "x-auth-token": token
    },
    url
  };
  if (_Object$keys(data).length > 0) request.data = data;
  return makeApiCall(request);
}, [([, endpoint]) => ({
  name: "getSecureAccountsApi",
  url: `${ACCOUNTS_API}/{username}${endpoint}`,
  type: "GET"
}), sessionDetailsMiddleware], apiErrorHandler);
export const getAccountsApi = apiWrapper(async ({
  params
}) => {
  const [data, endpoint, token] = params;
  const url = `${ACCOUNTS_API}${endpoint}`;
  let tokenClient;
  if (!token) {
    tokenClient = Vue.store.state.AccountStore.token;
  } else {
    tokenClient = token;
  }
  const request = {
    type: "GET",
    headers: {
      "content-type": "application/json",
      "x-auth-token": tokenClient
    },
    url: url
  };
  if (_Object$keys(data).length > 0) request.data = data;
  return makeApiCall(request);
}, [([, endpoint]) => ({
  name: "getAccountsApi",
  url: `${ACCOUNTS_API}${endpoint}`,
  type: "GET"
})], apiErrorHandler);
export const getLocal = () => {};
export const postMainApi = apiWrapper(async ({
  resources,
  params
}) => {
  const [data, endpoint, ajaxOptions = {}] = params;
  const {
    username,
    token,
    apiBasePath
  } = getAPIResourceData(resources);
  const url = `${MAIN_API}${apiBasePath}/${username}${endpoint}`;
  const defaultAjaxOption = {
    data: _JSON$stringify(data),
    type: "POST",
    headers: {
      "content-type": "application/json",
      "x-auth-token": token
    },
    url
  };
  return makeApiCall(_objectSpread(_objectSpread({}, defaultAjaxOption), ajaxOptions));
}, [([, endpoint]) => ({
  name: "postMainApi",
  url: `${MAIN_API}{apiBasePath}/{username}${endpoint}`,
  type: "POST"
}), sessionDetailsMiddleware], apiErrorHandler);
export const putMainApi = apiWrapper(async ({
  resources,
  params
}) => {
  const [data, endpoint] = params;
  const {
    username,
    token,
    apiBasePath
  } = getAPIResourceData(resources);
  const url = `${MAIN_API}${apiBasePath}/${username}${endpoint}`;
  return makeApiCall({
    data: _JSON$stringify(data),
    type: "PUT",
    headers: {
      "content-type": "application/json",
      "x-auth-token": token
    },
    url
  });
}, [([, endpoint]) => ({
  name: "putMainApi",
  url: `${MAIN_API}{apiBasePath}/{username}${endpoint}`,
  type: "PUT"
}), sessionDetailsMiddleware], apiErrorHandler);
export const putDocumentsApi = apiWrapper(async ({
  resources,
  params
}) => {
  const [data, endpoint] = params;
  const {
    username,
    token
  } = getAPIResourceData(resources);
  const url = `${DOCUMENTS_API}/${username}${endpoint}`;
  return makeApiCall({
    data: _JSON$stringify(data),
    type: "PUT",
    headers: {
      "content-type": "application/json",
      "x-auth-token": token
    },
    url
  });
}, [([, endpoint]) => ({
  name: "putDocumentsApi",
  url: `${DOCUMENTS_API}/{username}${endpoint}`,
  type: "PUT"
}), sessionDetailsMiddleware], apiErrorHandler);
export const postDocumentsApi = apiWrapper(async ({
  resources,
  params
}) => {
  const [data, endpoint] = params;
  const {
    username,
    token
  } = getAPIResourceData(resources);
  const url = `${DOCUMENTS_API}/${username}${endpoint}`;
  return makeApiCall({
    data: _JSON$stringify(data),
    type: "POST",
    headers: {
      "content-type": "application/json",
      "x-auth-token": token
    },
    url
  });
}, [([, endpoint]) => ({
  name: "postDocumentsApi",
  url: `${DOCUMENTS_API}/{username}${endpoint}`,
  type: "POST"
}), sessionDetailsMiddleware], apiErrorHandler);
export const putFile = apiWrapper(async ({
  resources,
  params
}) => {
  const [file, endpoint] = params;
  const {
    username,
    token,
    apiBasePath
  } = getAPIResourceData(resources);
  const url = `${MAIN_API}${apiBasePath}/${username}${endpoint}`;
  return makeApiCall({
    data: file,
    type: "PUT",
    processData: false,
    headers: {
      "content-type": "text/css",
      "x-auth-token": token
    },
    url
  });
}, [([, endpoint]) => ({
  name: "putFile",
  url: `${MAIN_API}{apiBasePath}/{username}${endpoint}`,
  type: "PUT"
}), sessionDetailsMiddleware], apiErrorHandler);
export const putFileAccounts = apiWrapper(async ({
  resources,
  params
}) => {
  const [file, endpoint] = params;
  const {
    username,
    token
  } = getAPIResourceData(resources);
  const url = `${ACCOUNTS_API}/${username}${endpoint}`;
  return makeApiCall({
    data: file,
    type: "PUT",
    processData: false,
    headers: {
      "content-type": "text/css",
      "x-auth-token": token
    },
    url
  });
}, [([, endpoint]) => ({
  name: "putFileAccounts",
  url: `${ACCOUNTS_API}/{username}${endpoint}`,
  type: "PUT"
}), sessionDetailsMiddleware], apiErrorHandler);
export const putS3Data = apiWrapper(async ({
  params
}) => {
  const [file, signedURL, signedType] = params;
  return makeApiCall({
    data: file,
    processData: false,
    type: "PUT",
    headers: {
      "content-type": signedType || file.type
    },
    url: signedURL
  });
}, [() => ({
  name: "putS3Data",
  type: "PUT"
})], apiErrorHandler);
export const deleteMainApi = apiWrapper(async ({
  resources,
  params
}) => {
  const [endpoint] = params;
  const {
    username,
    token,
    apiBasePath
  } = getAPIResourceData(resources);
  const url = `${MAIN_API}${apiBasePath}/${username}${endpoint}`;
  const request = {
    type: "DELETE",
    headers: {
      "content-type": "application/json",
      "x-auth-token": token
    },
    url
  };
  return makeApiCall(request);
}, [([endpoint]) => ({
  name: "deleteMainApi",
  url: `${MAIN_API}{apiBasePath}/{username}${endpoint}`,
  type: "DELETE"
}), sessionDetailsMiddleware], apiErrorHandler);
export const deleteDocumentsApi = apiWrapper(async ({
  resources,
  params
}) => {
  const [endpoint] = params;
  const {
    username,
    token
  } = getAPIResourceData(resources);
  const url = `${DOCUMENTS_API}/${username}${endpoint}`;
  const request = {
    type: "DELETE",
    headers: {
      "content-type": "application/json",
      "x-auth-token": token
    },
    url
  };
  return makeApiCall(request);
}, [([endpoint]) => ({
  name: "deleteDocumentsApi",
  url: `${DOCUMENTS_API}/{username}${endpoint}`,
  type: "DELETE"
}), sessionDetailsMiddleware], apiErrorHandler);
export const getMainApi = apiWrapper(async ({
  resources,
  params
}) => {
  const [data, endpoint, ajaxOptions = {}] = params;
  const {
    username,
    token,
    apiBasePath
  } = getAPIResourceData(resources);
  const url = `${MAIN_API}${apiBasePath}/${username}${endpoint}`;
  const defaultAjaxOptions = {
    type: "GET",
    headers: {
      "content-type": "application/json",
      "x-auth-token": token
    },
    url
  };
  if (_Object$keys(data).length > 0) defaultAjaxOptions.data = data;
  return makeApiCall(_objectSpread(_objectSpread({}, defaultAjaxOptions), ajaxOptions));
}, [([, endpoint]) => ({
  name: "getMainApi",
  url: `${MAIN_API}/{apiBasePath}/{username}${endpoint}`,
  type: "GET"
}), sessionDetailsMiddleware], apiErrorHandler);
export const deleteClientsApi = apiWrapper(async ({
  resources,
  params
}) => {
  const [endpoint] = params;
  const {
    username,
    token,
    apiBasePath,
    tiedBrokerages
  } = getAPIResourceData(resources);
  const {
    brokerageId
  } = tiedBrokerages[0];
  const url = `${MAIN_API}${apiBasePath}/${username}/brokerage/${brokerageId}${endpoint}`;
  const request = {
    type: "DELETE",
    headers: {
      "content-type": "application/json",
      "x-auth-token": token
    },
    url
  };
  return makeApiCall(request);
}, [([endpoint]) => ({
  name: "deleteClientsApi",
  url: `${MAIN_API}/{apiBasePath}/{username}/brokerage/{brokerageId}${endpoint}`,
  type: "GET"
}), sessionDetailsMiddleware], apiErrorHandler);
export const postClientsApi = apiWrapper(async ({
  resources,
  params
}) => {
  const [data, endpoint, newBrokerageId] = params;
  const {
    username,
    token,
    tiedBrokerages,
    apiBasePath
  } = getAPIResourceData(resources);
  let brokerageId;
  newBrokerageId ? brokerageId = newBrokerageId : brokerageId = tiedBrokerages[0].brokerageId;
  const url = `${MAIN_API}${apiBasePath}/${username}/brokerage/${brokerageId}${endpoint}`;
  return makeApiCall({
    data: _JSON$stringify(data),
    type: "POST",
    headers: {
      "content-type": "application/json",
      "x-auth-token": token
    },
    url
  });
}, [([, endpoint]) => ({
  name: "postClientsApi",
  url: `${MAIN_API}{apiBasePath}/{username}/brokerage/{brokerageId}${endpoint}`,
  type: "POST"
}), sessionDetailsMiddleware], apiErrorHandler);
export const putClientsApi = apiWrapper(async ({
  resources,
  params
}) => {
  const [data, endpoint] = params;
  const {
    username,
    token,
    tiedBrokerages,
    apiBasePath
  } = getAPIResourceData(resources);
  const {
    brokerageId
  } = tiedBrokerages[0];
  const url = `${MAIN_API}${apiBasePath}/brokerage/${brokerageId}/${username}${endpoint}`;
  return makeApiCall({
    data: _JSON$stringify(data),
    type: "PUT",
    headers: {
      "content-type": "application/json",
      "x-auth-token": token
    },
    url
  });
}, [([, endpoint]) => ({
  name: "putClientsApi",
  url: `${MAIN_API}{apiBasePath}/brokerage/{brokerageId}/{username}${endpoint}`,
  type: "POST"
}), sessionDetailsMiddleware], apiErrorHandler);
export const getClientsApi = apiWrapper(async ({
  resources,
  params
}) => {
  const [data, endpoint, newBrokerageId] = params;
  const {
    username,
    token,
    tiedBrokerages,
    apiBasePath
  } = getAPIResourceData(resources);
  let brokerageId;
  newBrokerageId ? brokerageId = newBrokerageId : brokerageId = tiedBrokerages[0].brokerageId;
  const url = `${MAIN_API}${apiBasePath}/${username}/brokerage/${brokerageId}${endpoint}`;
  const request = {
    type: "GET",
    headers: {
      "content-type": "application/json",
      "x-auth-token": token
    },
    url
  };
  if (_Object$keys(data).length > 0) request.data = data;
  return makeApiCall(request);
}, [([, endpoint]) => ({
  name: "getClientsApi",
  url: `${MAIN_API}{apiBasePath}/{username}/brokerage/{brokerageId}${endpoint}`,
  type: "GET"
}), sessionDetailsMiddleware], apiErrorHandler);
export const getPublicClientsApi = apiWrapper(async ({
  params
}) => {
  const [data, token, endpoint] = params;
  const url = `${MAIN_API}${endpoint}`;
  const request = {
    type: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: token
    },
    url
  };
  if (_Object$keys(data).length > 0) request.data = data;
  return makeApiCall(request);
}, [([, endpoint]) => ({
  name: "getPublicClientsApi",
  url: `${MAIN_API}${endpoint}`,
  type: "GET"
})], apiErrorHandler);
export const postPublicClientsApi = apiWrapper(async ({
  params
}) => {
  const [data, token, endpoint] = params;
  const url = `${MAIN_API}${endpoint}`;
  return makeApiCall({
    data: _JSON$stringify(data),
    type: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: token
    },
    url
  });
}, [([,, endpoint]) => ({
  name: "postPublicClientsApi",
  type: "POST",
  url: `${MAIN_API}${endpoint}`
})], apiErrorHandler);
export const putPublicClientsApi = apiWrapper(async ({
  params
}) => {
  const [data, token, endpoint] = params;
  const url = `${MAIN_API}${endpoint}`;
  return makeApiCall({
    data: _JSON$stringify(data),
    type: "PUT",
    headers: {
      "content-type": "application/json",
      Authorization: token
    },
    url
  });
}, [([,, endpoint]) => ({
  name: "postPublicClientsApi",
  type: "PUT",
  url: `${MAIN_API}${endpoint}`
})], apiErrorHandler);
export const getDocumentsApi = apiWrapper(async ({
  resources,
  params
}) => {
  const [data, endpoint] = params;
  const {
    username,
    token
  } = getAPIResourceData(resources);
  const url = `${DOCUMENTS_API}/${username}${endpoint}`;
  const request = {
    type: "GET",
    headers: {
      "content-type": "application/json",
      "x-auth-token": token
    },
    url
  };
  if (_Object$keys(data).length > 0) request.data = data;
  return makeApiCall(request);
}, [([, endpoint]) => ({
  name: "getDocumentsApi",
  url: `${DOCUMENTS_API}/{username}${endpoint}`,
  type: "GET"
}), sessionDetailsMiddleware], apiErrorHandler);
export const getDocumentsApiNoAuth = apiWrapper(async ({
  params
}) => {
  const [data, endpoint] = params;
  const url = `${DOCUMENTS_API}/${endpoint}`;
  const request = {
    type: "GET",
    headers: {
      "content-type": "application/json"
    },
    url
  };
  if (_Object$keys(data).length > 0) request.data = data;
  return makeApiCall(request);
}, [([, endpoint]) => ({
  name: "getDocumentsApi",
  url: `${DOCUMENTS_API}/${endpoint}`,
  type: "GET"
})], apiErrorHandler);
export const putDocumentsApiNoAuth = apiWrapper(async ({
  params
}) => {
  const [data, endpoint] = params;
  const url = `${DOCUMENTS_API}/${endpoint}`;
  return makeApiCall({
    data: _JSON$stringify(data),
    type: "PUT",
    headers: {
      "content-type": "application/json"
    },
    url
  });
}, [([, endpoint]) => ({
  name: "putDocumentsApi",
  url: `${DOCUMENTS_API}/{username}${endpoint}`,
  type: "PUT"
})], apiErrorHandler);
export const get = apiWrapper(async ({
  resources,
  params
}) => {
  const [data, url] = params;
  const {
    token
  } = getAPIResourceData(resources);
  const request = {
    type: "GET",
    headers: {
      "content-type": "application/json",
      "x-auth-token": token
    },
    url: url
  };
  if (_Object$keys(data).length > 0) request.data = data;
  return makeApiCall(request);
}, [() => ({
  name: "get",
  type: "GET"
}), sessionDetailsMiddleware], apiErrorHandler);
export const getPublicApi = apiWrapper(async ({
  params
}) => {
  const [data, url] = params;
  const request = {
    type: "GET",
    headers: {
      "content-type": "application/json"
    },
    url: url
  };
  if (_Object$keys(data).length > 0) request.data = data;
  return makeApiCall(request);
}, [() => ({
  name: "getPublicApi",
  type: "GET"
})], apiErrorHandler);
export const getPublicDocumentsApi = apiWrapper(async ({
  params
}) => {
  const [data, token, endpoint] = params;
  const url = `${DOCUMENTS_API}${endpoint}`;
  const request = {
    type: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: token
    },
    url
  };
  if (_Object$keys(data).length > 0) request.data = data;
  return makeApiCall(request);
}, [([,, endpoint]) => ({
  name: "getPublicDocumentsApi",
  type: "GET",
  url: `${DOCUMENTS_API}${endpoint}`
})], apiErrorHandler);
export const postPublicDocumentsApi = apiWrapper(async ({
  params
}) => {
  const [data, token, endpoint] = params;
  const url = `${DOCUMENTS_API}${endpoint}`;
  return makeApiCall({
    data: _JSON$stringify(data),
    type: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: token
    },
    url: url
  });
}, [([,, endpoint]) => ({
  name: "postPublicDocumentsApi",
  type: "POST",
  url: `${DOCUMENTS_API}${endpoint}`
})], apiErrorHandler);
export const headCacheCheck = filePath => {
  return makeApiCall({
    type: "HEAD",
    url: filePath
  });
};
export const postExternalApi = apiWrapper(async ({
  params
}) => {
  const [data, endpoint, ajaxOptions = {}] = params;
  const url = `${EXTERNAL_API}${endpoint}`;
  const defaultAjaxOption = {
    data: _JSON$stringify(data),
    type: "POST",
    headers: {
      "content-type": "application/json"
    },
    url
  };
  return makeApiCall(_objectSpread(_objectSpread({}, defaultAjaxOption), ajaxOptions));
}, [([, endpoint]) => ({
  name: "postExternalApi",
  type: "POST",
  url: `${EXTERNAL_API}${endpoint}`
})], apiErrorHandler);